import script from "./TwoFactorSetupForm.vue?vue&type=script&setup=true&lang=js"
export * from "./TwoFactorSetupForm.vue?vue&type=script&setup=true&lang=js"

import "./TwoFactorSetupForm.vue?vue&type=style&index=0&id=53eb503e&scoped=true&lang=css"

import exportComponent from "/home/forge/hike.marketing/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-53eb503e"]])

export default __exports__